<template lang="pug">
    PrintablePanel
      PageHeader
        | Transaction Summary Report
        span.pl-2.ml-2.border-left.body-1
          router-link(:to="{name: 'transaction_summary'}") Refine Search
      .mt-3.d-flex(v-if="!printable")
        .ml-auto
          button.btn.btn-primary.mr-2(@click.prevent="downloadCsv('storesummary.csv', csvRecords)") Download CSV
          router-link.btn.btn-primary(:to="{query: {print: true}}" target="_blank") Print
      .d-flex.mt-3
        div
          | Search range:
          strong &nbsp; {{ fromDate }}
          | &nbsp; -
          strong &nbsp; {{ toDate }}
      Datatable.mt-4(
        :columns="columns"
        header-class="body-3"
        header-style="font-weight: bold;"
        :per-page="10"
        :sortable="true"
        :sort-keys="sortKeys"
        :entries="results"
        @sortTable="sort"
      )
        template(slot-scope="props")
          tr.body-3
            td {{ props.entry.stateCd }}
            td {{ props.entry.countyName }}
            td
              | {{ parseInt(props.entry.submittingStores).toLocaleString() }}
              router-link.ml-1(
                :to="{name: 'transaction_summary_results2', query: {id: props.entry.fipsCd, f: fromDate, t: toDate}}"
              ) View Details
            td {{ parseInt(props.entry.totalActivity).toLocaleString() }}
            td {{ parseInt(props.entry.totalSold).toLocaleString() }}
            td {{ parseInt(props.entry.totalBlocks).toLocaleString() }}
    
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import Datatable from '@/components/Datatable'
import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'
import { parse } from 'date-fns/esm'
import { downloadCsv } from '@/lib/csv'

async function getData(id) {
  let resp = await axios().get('/api/reports/link', { params: { id } })
  return resp
}
export default {
  name: 'StoreSummaryResults1',
  data() {
    return {
      fromDate: '',
      toDate: '',
      results: [],
      columns: [
        'State',
        'County/Parish',
        'Submitting Stores',
        'Total Activity',
        'Total Purchases',
        'Total Blocked',
      ],
      sortKeys: [
        'stateCd',
        'countyName',
        'submittingStores',
        'totalActivity',
        'totalSold',
        'totalBlocks',
      ],
    }
  },
  methods: {
    downloadCsv,
    fmtTime: e => `${e.year}-${e.month}`,
    sort(info) {
      // If sorting by date, use a special sort, otherwise sort like normal
      if (info.sortKey === 'date') {
        this.results.sort(
          (a, b) =>
            parse(this.fmtTime(a), 'yyyy-MM', new Date()).getTime() -
            parse(this.fmtTime(b), 'yyyy-MM', new Date()).getTime(),
        )
      } else {
        this.results.sort((a, b) => {
          let aa = a[info.sortKey]
          let bb = b[info.sortKey]

          // If these can be treated as floats, then treat them as floats.
          let af = parseFloat(aa)
          let bf = parseFloat(bb)
          if (af && bf) {
            aa = af
            bb = bf
          }

          return aa < bb ? -1 : aa > bb ? 1 : 0
        })
      }
      if (info.sortDir === 'desc') this.results.reverse()
    },
  },
  computed: {
    csvRecords() {
      return this.results.map(r => {
        return {
          State: r.stateCd,
          'County/Parish': r.countyName || '',
          'Submitting Stores': r.submittingStores || '',
          'Total Activity': r.totalActivity || '',
          'Total Purchases': r.totalSold || '',
          'Total Blocked': r.totalBlocks || '',
        }
      })
    },
  },
  beforeRouteEnter(to, _from, next) {
    getData(to.params.id)
      .then(resp => {
        scrollTo(0, 0)
        next(vm => {
          vm.results = resp.data.results
          vm.fromDate = resp.data.criteria.fromDate
          vm.toDate = resp.data.criteria.toDate
          if (vm.printable) vm.$nextTick(() => window.print())
        })
      })
      .catch(err => {
        scrollTo(0, 0)
        globalError(err)
      })
  },
  components: {
    Datatable,
    PageHeader,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
.border-left {
  border-left: 2px solid #e6e6e6;
}
</style>
